import React, { useState, useEffect } from "react";
import "./App.css";
import WrappedMap from "./Map";
import config from "./config";
import useFetch from "./useFetch";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Header from "./Header";
import { distanceBetweenTwoPts } from "./haversine";

function LiveTracker() {
  const [unFilteredData, setUnFilteredData] = useState([]);
  const [selectedTime, setSelectedTime] = useState("3h");
  const [selectedMachine, setSelectedMachine] = useState("AC:15:18:F7:6C:68");

  const { data: stops } = useFetch(
    "https://61a4a0604c822c0017041d33.mockapi.io/shuttle/v1/stops"
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://argriapi.techexposys.com/machine-tracking/coordinates-history",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              time: selectedTime,
              topic: "tes/tracker",
              macaddress: selectedMachine,
            }),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        if (Array.isArray(data) && data.length > 0) {
          setUnFilteredData(data);
        } else {
          setUnFilteredData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setUnFilteredData([]);
      }
    };

    fetchData();
    const intervalId = setInterval(fetchData, 5000);
    return () => clearInterval(intervalId);
  }, [selectedTime, selectedMachine]);

  const paths =
    unFilteredData?.filter((data) => data.lat !== 0 && data.lng !== 0) || [];

  let totalDistance = 0;
  for (let i = paths.length - 1; i > 0; i--) {
    const lat1 = paths[i].lat;
    const lon1 = paths[i].lng;
    const lat2 = paths[i - 1].lat;
    const lon2 = paths[i - 1].lng;
    totalDistance += distanceBetweenTwoPts(lat1, lon1, lat2, lon2);
  }

  let timestamp1, timestamp2;
  if (paths && paths.length > 0) {
    timestamp1 = paths[0].timeStamp;
    timestamp2 = paths[paths.length - 1].timeStamp;
  }
  const date1 = new Date(timestamp1);
  const date2 = new Date(timestamp2);
  const diffInMilliseconds = date2 - date1;
  const diffInSeconds = diffInMilliseconds / 1000;
  const diffInMinutes = diffInSeconds / 60;
  const diffInHours = diffInMinutes / 60;
  const hours = Math.floor(diffInHours);
  const minutes = Math.floor(diffInMinutes % 60);
  const seconds = Math.floor(diffInSeconds % 60);
  const milliseconds = diffInMilliseconds % 1000;

  if (![hours, minutes, seconds, milliseconds].includes(NaN)) {
    console.log(
      `Total time is : ${hours} hours, ${minutes} minutes, ${seconds} seconds, and ${milliseconds} milliseconds`
    );
  }

  let pathsLength = paths.length - 1;
  if (paths && paths.length > 0) {
    console.log("Current Battery is : " + paths[pathsLength].battery);
    localStorage.setItem("battery", paths[pathsLength].battery);
    console.log(
      "Current Location : latitude , longitude and altitude is : " +
        paths[pathsLength].lat +
        ", " +
        paths[pathsLength].lng +
        " ," +
        paths[pathsLength].altitude
    );
    if (paths[pathsLength].power === 0) {
      console.log(
        "Main Power is : OFF\n -----------------------------------------"
      );
      localStorage.setItem("power", "OFF");
    } else {
      console.log(
        "Main Power is : ON\n ------------------------------------------"
      );
      localStorage.setItem("power", "ON");
    }
  }

  const mapURL = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${config.mapsKey}`;

  return (
    <div className="App">
      <Header
        selectedTime={selectedTime}
        setSelectedTime={setSelectedTime}
        selectedMachine={selectedMachine}
        setSelectedMachine={setSelectedMachine}
      />
      {paths && stops ? (
        <WrappedMap
          selectedMachine={selectedMachine}
          paths={paths}
          stops={stops}
          googleMapURL={mapURL}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div className="mapContainer" />}
          mapElement={<div style={{ height: `100%` }} />}
        />
      ) : (
        <Box sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
      )}
    </div>
  );
}

export default LiveTracker;
